import AddingTheBot from './invite.PNG'
export default {
  AddingTheBot
} 